//TODO: REFACTOR
export const agAddressCardHeight = (
  agAddressType: string,
  type: string,
  bannerEnabled: boolean,
  hideBannerDisplay: boolean
): string => {
  const heightMap = {
    'ag-all': { open: `${bannerEnabled ? 870 : 820}`, close: `${bannerEnabled ? 680 : 630}` },
    'ag-mn': { open: `${bannerEnabled ? 890 : 825}`, close: `${bannerEnabled ? 690 : 640}` },
    'ag-none': { open: `${bannerEnabled ? 770 : 680}`, close: `${bannerEnabled ? 630 : 580}` },
  };
  const height = heightMap[agAddressType]?.[type] - (hideBannerDisplay && bannerEnabled ? 50 : 0);
  return `${height}px`;
};
